import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';
import { Button as BootstrapButton } from 'react-bootstrap';

import { Icon } from '../Icon';

import styles from './button.module.css';

const Button = ({
  children,
  className,
  variant,
  size = 'lg',
  icon = '',
  iconClass = 'text-lg text-white',
  ...props
}) => {
  return (
    <BootstrapButton
      variant={variant}
      className={classNames(className, styles[variant] || styles.button, [
        variant !== 'link' && styles[size],
      ])}
      {...props}
    >
      {icon && (
        <Icon
          className={classNames(children ? 'mr-2' : '', iconClass)}
          name={icon}
        />
      )}
      {children}
    </BootstrapButton>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'warning',
    'danger',
    'light',
    'link',
  ]),
  size: PropTypes.string,
  icon: PropTypes.string,
  iconClass: PropTypes.string,
};

export default Button;
